import React, { useState, useEffect, useRef } from 'react';
import { navigate } from 'gatsby';
import Select from 'react-select';
import GamePlay from './gamePlay';

import promotion_config from '../../../promotion_config';

export const EntryForm = ({
    promotion_id,
    promotion,
    appUrl,
    createfunc,
    drawTicket,
    entry,
    game,
    animation,
    actions,
}) => {
    const formUrl = appUrl + '/entry.php';

    const initialState = {
        promotion: promotion,
        ticket1_1_1: promotion_id,
        ticket1_1_2: '',
        ticket1_2_1: '',
        entry_method: 'MANUAL_WEB',
        form_submitted: '1',
        'entry-submit': 'SUBMIT+ENTRY',
    };

    const [formState, setFormState] = useState(initialState);

    const [disabled, setDisabled] = useState(false);

    const selectGameNumberRef = useRef();

    useEffect(() => {
        clearIfSuccess();
    }, [drawTicket]);

    // fire the submission
    const handleSubmit = async event => {
        event.preventDefault();

        setDisabled(true);
        await createfunc(formState);
        document.getElementById('entry-alert').scrollIntoView(true);
        setDisabled(false);
    };

    // if the form field changes, we will change the value in the store and
    // also check if the next field must be focused
    const handleChange = function(event) {
        const target = event.target;
        const value =
            target.type === 'checkbox'
                ? target.checked
                : target.value === undefined
                ? ''
                : target.value.toUpperCase();
        const name = target.name;

        setFormState({ ...formState, [name]: value });

        autotab(target, target.dataset.next);
    };

    // if the form submit was a success, we clear the form
    const clearIfSuccess = async () => {
        if (drawTicket.success) {
            // UNCOMMENT FOR GAME MODAL on URL
            await actions.gameActions.getGame(entry.last_entry);

            setFormState(initialState);
            actions.entryActions.getEntries();
        }
    };

    // rehash of old autotab functionality from PA
    const autotab = (current, nex) => {
        var next = document.getElementById(nex);

        if (
            !!nex &&
            !!current &&
            !!next &&
            current.getAttribute &&
            current.value.length === parseInt(current.getAttribute('maxlength'))
        ) {
            next.focus();
        }
    };

    //* Interactive Game section
    const [gameUrl, setGameUrl] = useState(null);

    const setGamePlayed = async gameurl => {
        await actions.gameActions.setEntryFlashGameFlag({
            entry_id: entry.last_entry ? entry.last_entry.id : 0,
        });

        navigate(gameurl);
    };

    const setGameSkipped = async () => {
        await actions.gameActions.reset();
        await actions.drawTicketActions.reset();
        await setGameUrl(null);
        selectGameNumberRef.current.select.clearValue();
    };

    useEffect(() => {
        setGameUrl(game.game);
    }, [game]);

    //! 🛠 Testing section !//
    let showGameTestButton = false;
    if (promotion_config.development.testing.enabled) {
        showGameTestButton =
            promotion_config.development.testing.showGameTestButton !== null
                ? promotion_config.development.testing.showGameTestButton
                : showGameTestButton;
    }

    return (
        <div id="form-target" className="entry-form">
            {showGameTestButton ? (
                <button
                    onClick={() => actions.gameActions.getGame({ points: 5 })}
                >
                    QA TEST: Show Interactive Game
                </button>
            ) : null}

            <form
                name="ticket_entry"
                id="ticket_entry"
                action={formUrl}
                disabled={disabled}
                method="post"
                encType="application/x-www-form-urlencoded"
                onSubmit={handleSubmit}
            >
                <div className="flush-row entry-fields">
                    <div className="col-md">
                        <div className="form-group">
                            <label htmlFor="gameid" className="entry-number">
                                Select the holiday game
                            </label>
                            <Select
                                onChange={val => {
                                    handleChange({
                                        target: {
                                            ...val,
                                            name: 'ticket1_1_1',
                                            type: 'select',
                                            dataset: { next: 'ticket1_2_1' },
                                        },
                                    });
                                }}
                                ref={selectGameNumberRef}
                                placeholder="Choose One"
                                options={promotion_config.tickets}
                                className="react-select-container"
                                classNamePrefix="react-select"
                            />
                        </div>
                    </div>
                </div>
                <div className="flush-row entry-fields">
                    <div className="col-md">
                        <div className="form-group">
                            <label
                                htmlFor="ticket1_1_2"
                                className="entry-number"
                            >
                                ENTER THE 2nd chance app code ON FRONT
                            </label>
                            <input
                                type="text"
                                name="ticket1_1_2"
                                id="ticket1_1_2"
                                data-next="entry-submit"
                                title="2nd chance app code"
                                value={formState.ticket1_1_2}
                                onChange={handleChange}
                                size="8"
                                maxLength="8"
                                className="form-control entry-input ls-large"
                            />
                        </div>
                    </div>
                </div>
                <div className="flush-row entry-fields">
                    <div className="col-md">
                        <p className="text-center">
                            (Scroll further down on this page for more
                            instructions.)
                        </p>
                        <input
                            id="entry-submit"
                            type="submit"
                            name="submit"
                            className="d-block mx-auto entry-btn entry-submit"
                            value="SUBMIT"
                            title="Submit"
                            disabled={disabled}
                        />
                    </div>
                </div>
                <input
                    type="hidden"
                    id="entry_method"
                    name="entry_method"
                    value={formState.entry_method}
                />
                <input
                    type="hidden"
                    id="form_submitted"
                    name="form_submitted: '1'"
                    value={formState.form_submitted}
                />
            </form>

            <GamePlay
                game_url={gameUrl}
                skip_url="#!"
                showModal={gameUrl ? true : false}
                onGamePlayed={setGamePlayed}
                closeModal={setGameSkipped}
                entry={entry}
            />
        </div>
    );
};

export default EntryForm;
